module.exports = __webpack_public_path__ + "static/media/provider1.0a88ef0e.png";